module.exports = __webpack_public_path__ + "media/styles/images/png/circle-left-arrow-gray-light-on-white-0a47bfe7d9273f947e2ce49bf219adfe.png";